<ng-container *ngIf="code === '404';else errs">
    <div class="page__error erpg">
        <div class="erpg__bg"></div>
        <div class="erpg__block erpg__block--main">
            <div class="erpg__error">{{ code }}</div>

            <!--HEADER START-->
            <ng-container *ngIf="isStream === 'true';else HeadNotPage">
                <ng-container *ngIf="data!.sport || data!.tournament;else dscrTmpl">
                    <h1 class="erpg__title title-b" i18n="Cтраница ошибок/трансляция не существует@@ERROR_PAGE_STREAM_NOT_FOUND" dir="auto">Stream not found</h1>
                    <div class="erpg__desc text" i18n="Cтраница ошибок/трансляция не существует,частично верный url@@ERROR_PAGE_STREAM_DSCR" dir="auto">
                        <p dir="auto">It may have been completed, deleted, or it never existed.</p>
                        <p dir="auto">
                            You can start all over again by going to the main page and see all the Live matches. You may be interested in streams from the following categories:
                        </p>
                    </div>
                </ng-container>
                <ng-template #dscrTmpl>
                    <h1 class="erpg__title title-b" dir="auto" i18n="Cтраница ошибок/страница не найдена@@ERROR_PAGE_NOT_FOUND_STRM">Page not found</h1>
                    <div class="erpg__desc text" dir="auto" i18n="Cтраница ошибок/трансляция не существует,не верный url@@ERROR_PAGE_STREAM_DSCR2">
                        <p>You can start from the main page and see all Live streams.</p>
                    </div>
                </ng-template>
            </ng-container>

            <ng-template #HeadNotPage>
                <h1 class="erpg__title title-b" dir="auto" i18n="Cтраница ошибок/страница не найдена@@ERROR_PAGE_NOT_FOUND_STRM">Page not found</h1>
                <div class="erpg__desc text" dir="auto">
                    <p i18n="Cтраница ошибок/страница не найдена,message@@ERROR_PAGE_NOT_PAGE_DSCR" dir="auto">We're sorry, the page you are looking for doesn't exist. We advise you to return to the main page</p>
                </div>
            </ng-template>
            <!--HEADER END-->
            <!--BtnCategories START-->
            <div *ngIf="data?.sport"
                 class="erpg__sports">
                <div class="erpg__sport text">
                    <a [routerLink]="'/'+(data?.sport?.count?.live ? 'live/':'soon/')+(data?.sport?.alias ? data?.sport?.alias:data?.sport?.id+'/')"
                       class="wrd-ell" dir="auto">{{data?.sport?.name}}</a>
                    <span *ngIf="data?.sport?.count?.live"
                          class="_icon-online grey" dir="auto">{{data?.sport?.count?.live}}</span>
                    <span *ngIf="data?.sport?.count?.not_started"
                          class="_icon-clock grey" dir="auto">{{data?.sport?.count?.not_started}}</span>
                </div>
                <div *ngIf="data?.tournament"
                     class="erpg__sport text">
                    <a [routerLink]="'/'+ (data?.tournament?.count?.live ? 'live/':'soon/')+(data?.sport?.alias ? data?.sport?.alias : data?.sport?.id)+'/'+(data?.tournament?.alias ? data?.tournament?.alias : data?.tournament?.id+'/')"
                       class="wrd-ell" dir="auto">{{data?.tournament?.name}}&lrm;</a>
                    <span *ngIf="data?.tournament?.count?.live"
                          class="_icon-online grey" dir="auto">{{data?.tournament?.count?.live}}</span>
                    <span *ngIf="data?.tournament?.count?.not_started"
                          class="_icon-clock grey" dir="auto">{{data?.tournament?.count?.not_started}}</span>
                </div>
            </div>
            <!--BtnCategories END-->

            <a [routerLink]="['/live/']" class="btn btn--orng" i18n="Страница ошибок, кнопка на главную@@WORD_HOMEPAGE">Main page</a>
        </div>
        <!--Others-->
        <ng-container *ngIf="data && data['others'] && data['others'].length >0">
            <ng-container [ngTemplateOutlet]="others" ; [ngTemplateOutletContext]="{arr:data['others']}"></ng-container>
        </ng-container>
    </div>
    <ng-template #others let-arr="arr">
        <div class="erpg__block">
            <div class="erpg__ttl">
                <i class="_icon-fire"></i>
                <h2 class="text" i18n="Cтраница ошибок/список трансляций@@ERROR_PAGE_TOP">TOP streams</h2>
            </div>
            <div class="erpg__translations">
                <div class="translation__block" *ngFor="let m of arr | sortDate | slice:0:6">
                    <div class="translation__champ text">
                        <a [routerLink]="'/'+ (data?.tournament?.count?.live ? 'live/':'soon/')+(m.sport?.alias ? m.sport?.alias : m.sport?.id)+'/'+(m.tournament?.alias ? m.tournament?.alias : m.tournament?.id)" dir="auto">{{m.tournament!.name}}</a>
                    </div>
                    <div class="translation__match match"
                         [match]="m"
                         [sport]="m.sport!"
                         [tour]="m.tournament!"
                         type="err"></div>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #errs>
    <div class="page__error erpg">
        <div class="erpg__bg"></div>
        <div class="erpg__block erpg__block--main">
            <div class="erpg__error">{{ code }}</div>
            <h1 class="erpg__title title-b" dir="auto">{{ message }}</h1>
            <a [routerLink]="['/live/']" class="btn btn--orng" i18n="Страница ошибок, кнопка на главную@@WORD_HOMEPAGE" dir="auto">Main page</a>
        </div>
    </div>
</ng-template>

